import ThreeDSTab from './ThreeDSTab';

export default ThreeDSTab;